import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials is not needed for token-based auth
  // Removing it fixes CORS issue when backend uses wildcard Access-Control-Allow-Origin
});

export default instance;